export default "__VITE_ASSET___st55F2H__"